<script>
  import { isEnglish, setIsEnglish } from "../stores/cookies.js";
  import BottomCard from "../components/BottomCard.svelte";
  import AppBar from "../components/AppBar.svelte";
  import ContactForm from "../components/ContactForm.svelte";
</script>

<AppBar />

<main class="p-4 mx-auto space-y-6">
  <h1
    class="
    text-center md:text-left
    text-blue-900 font-bold
    text-2xl sm:text-3xl md:text-4xl lg:text-5xl
    tracking-tight
    pl-6 sm:pl-8 md:pl-12 lg:pl-16 xl:pl-24 2xl:pl-32
    pt-0 sm:pt-2 md:pt-4 lg:pt-6 xl:pt-8 2xl:pt-10
  "
  >
    {$isEnglish ? "Contact Form" : "Kontak Vorm"}
  </h1>

  <!-- Contact Emails -->
  <div
    class="
      text-center md:text-left
      pl-6 sm:pl-8 md:pl-12 lg:pl-16 xl:pl-24 2xl:pl-32
      space-y-2
      text-gray-700
    "
  >
    <p>
      <span class="font-semibold">
        {$isEnglish ? "Vredenburg:" : "Vredenburg:"}
      </span>
      <a
        href="mailto:admin@vburgdiere.co.za"
        class="text-blue-700 hover:underline"
      >
        admin@vburgdiere.co.za
      </a>
    </p>

    <p>
      <span class="font-semibold">
        {$isEnglish ? "Langebaan:" : "Langebaan:"}
      </span>
      <a
        href="mailto:admin@langebaanvet.co.za"
        class="text-blue-700 hover:underline"
      >
        admin@langebaanvet.co.za
      </a>
    </p>
  </div>

  <ContactForm />

  <BottomCard />
</main>
